import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import * as User from "../redux/user";
import { Link } from "react-router-dom";
import ButtonDropdown from "reactstrap/lib/ButtonDropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownItem from "reactstrap/lib/DropdownItem";
import history from "src/plugins/history";
import { HeaderPage } from "./HeaderPage";
import { Prestation, Proposal } from "src/redux/projects";
interface Props {
  organization: User.Organization;
  profil: User.Profil;
  currentLocation: string;
  prestation?: Prestation;
  proposal?: Proposal;
  logout: () => void;
}
interface State {
  dropdownOpen: boolean;
}
type PropsWithNamespaces = Props & WithNamespaces;
class Header extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    dropdownOpen: false
  };
  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };
  loggedOut = () => {
    localStorage.removeItem("authToken");
    this.props.logout();
    history.push("/login");
  };
  translateType = proposalType => {
    switch (proposalType) {
      case "PlanDecoration":
        return this.props.t("proposal.type.plandecoration");
      case "Artwork":
        return this.props.t("proposal.type.artwork");
      case "POV":
        return this.props.t("proposal.type.pov");
      default:
        return;
    }
  };
  render() {
    const prestationName = this.props.prestation
      ? this.props.prestation.name
      : "";
    const proposalType = this.props.proposal
      ? ` - ${this.translateType(this.props.proposal.type)}`
      : "";
    return (
      <div className="header">
        <div className="header-logo">
          <Link to="/" className="h-100">
            <div className="logo" />
          </Link>
        </div>
        <div className="header-projectDeveloper">
          <div className="flex-grow-1">
            {this.props.currentLocation.indexOf("proposal") > 0 ? (
              <div>
                <HeaderPage title={prestationName + proposalType} back={true} />
              </div>
            ) : (
              <p className="h1 text-uppercase">
                {this.props.t(`header.title`)}
              </p>
            )}
          </div>
          <div className="d-flex">
            <div className="header-projectDeveloper-infos">
              <ButtonDropdown
                isOpen={this.state.dropdownOpen}
                toggle={this.toggle}
              >
                <DropdownToggle>
                  {this.props.profil.lastname} {this.props.profil.firstname}{" "}
                  <img src="assets/svgs/right-chevron-white.svg" />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <Link to="/profil">
                      {this.props.t(
                        `header.projectDeveloper.dropDownMenu.coords`
                      )}
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link to="/account">
                      {this.props.t(
                        `header.projectDeveloper.dropDownMenu.account`
                      )}
                    </Link>
                  </DropdownItem>
                  <DropdownItem onClick={this.loggedOut}>
                    {this.props.t(
                      `header.projectDeveloper.dropDownMenu.disconnect`
                    )}
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(Header);



// WEBPACK FOOTER //
// ./src/components/Header.tsx